export default __webpack_public_path__ + "static/media/1863.6557a49c.png";